<template>
  <div :class="showForm ? 'overflow-hidden' : ''">
    <!-- Form -->
    <div
      v-if="showForm"
      class="animate__animated animate__slideInRight animate__faster">
      <form
        @submit.prevent="submitDelete"
        :id="record.id + '-form'">
        <textarea
          type="text"
          class="form-control"
          placeholder="Enter Reason"
          v-model="reason"
          required/>
        <div class="btn-group w-100">
          <button
            class="btn btn-sm btn-primary"
            type="submit">
            <i class="fa fa-paper-plane"/>
            Submit
          </button>
          <button
            class="btn btn-sm btn-primary"
            type="button"
            @click="toggleForm">
            <i class="fa fa-ban"/>
            Cancel
          </button>
        </div>
      </form>
    </div>
    <!-- Default dropstart button -->
    <div
      v-else
      class="dropstart">
      <button type="button" class="btn btn-sm btn-primary" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="fa fa-ellipsis-h"/>
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
        <li>
          <a
            class="dropdown-item" href="#"
            @click="toggleForm">
            <i class="fa fa-trash"/>
            Delete
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
  import { ref, watch, nextTick } from 'vue';
  import { useStore } from 'vuex';

  // Initialize
  const props = defineProps(['record', 'customer', 'item'])
  const store = useStore()

  // Data
  const showForm = ref(false)
  const reason = ref('')

  // Watchers
  watch(showForm, async (newVal)=>{
    await nextTick()
    if(newVal){
      setTimeout(()=>{
        const elm = document.getElementById(`${props.record.id + '-form'}`)
        elm.querySelector('textarea').focus()
      },500)
    }
  })

  // Methods
  const toggleForm = ()=>{
    showForm.value = !showForm.value
  }

  const submitDelete = ()=>{
    const data = {
      reason: reason.value,
      record: props.record,
      customer: props.customer,
      item: props.item,
      qty: -1
    }
    store.dispatch('displayTrackingTransaction', data)
  }

</script>